/* eslint-disable */
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        // Dropdown icon for login menu
        var openIcon = '<img class="openicon" src="' + js_vars.openicon + '">';
        $('.secondary-links .menu-item-has-children').append(openIcon);

      },

      finalize: function() {

        var $oSelf = this;

        jQuery('.desktop-banner-body .primary-links > ul > li.menu-item-has-children > a').on('click', function(e) {
          
          e.preventDefault();
          
          if (!$(this).parent().hasClass('menu-active')) {
            $('.menu-active').removeClass('menu-active');
            $('#page-modules').addClass('blurred-element');
            $('#page-header').addClass('blurred-element');
            $('#menu-close-background').addClass('show');
            $('#hero').addClass('blurred-element');
            $(this).parent().addClass('menu-active');
          } else {
            $('.menu-active').removeClass('menu-active');
            $('.sub-menu-active').removeClass('sub-menu-active');
            $('#menu-close-background').removeClass('show');
            $('#page-modules').removeClass('blurred-element');
            $('#page-header').removeClass('blurred-element');
            $('#hero').removeClass('blurred-element');
          }
        });

        jQuery('#menu-close-background').on('click', function(e) {
          $('.menu-active').removeClass('menu-active');
          $('#page-modules').removeClass('blurred-element');
          $('#page-header').removeClass('blurred-element');
          $('#hero').removeClass('blurred-element');
        });

        jQuery('.desktop-banner-body .primary-links ul[data-tier=2] li.menu-item-has-children > a').on('click', function(e) {
        
          e.preventDefault();
          
          if (!$(this).parent().hasClass('sub-menu-active')) {
            $('.sub-menu-active').removeClass('sub-menu-active');
            $(this).parent().addClass('sub-menu-active');
          } else {
            $(this).parent().removeClass('sub-menu-active');
          }
        });

        jQuery('#hero').slick({
          arrows: false,
          autoplay: true,
          autoplaySpeed: 8000,
          cssEase: 'ease',
          dots: true,
          fade: true,
          infinite: true,
          pauseOnHover: false,
          adaptiveHeight: false,
          speed: 1500,
          customPaging: function(slider, i) {
            var thumb = jQuery(slider.$slides[i]).data(); 
    
            return '<a>0' + (i + 1) + '</a>';
          },
        });

        // Open search form on button click
        $('#search-toggle').on('click', function(e) {

          e.preventDefault();
          $('#search-bar').toggleClass('open');

        });

        if ($('.gallery').length) {

          var galleryNumber = 1;

          $('.gallery').each(function() {

            var gallery = '#gallery-' + galleryNumber;

            var galleryColumns = this.className.match(/gallery-columns-\d+/);

            var columnNumber = galleryColumns[0].split('-');

            columnNumber = parseInt(columnNumber[2]);

            $(gallery).slick({
              infinite: true,
              speed: 300,
              slidesToShow: columnNumber,
              prevArrow: '<span class=\'slick-prev\'><img src=\'/wp-content/themes/intelsius/dist/images/icons/prev-arrow.svg\' alt=\'Previous Slide\'></span>',
              nextArrow: '<span class=\'slick-next\'><img src=\'/wp-content/themes/intelsius/dist/images/icons/next-arrow.svg\' alt=\'Next Slide\'></span>',
              slidesToScroll: columnNumber,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  },
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ],
            });

            galleryNumber++;

          });

        }

        // TEMPORARY - 134-top-level-pages-discuss
        // Disable top level links until client has pages ready
        // $('#banner a').on('click', function(e) {
        //   if ($(this).attr('title')){
        //     e.preventDefault();
        //     console.log('Top level links currently disabled.');
        //   }
        // })
        // // Disable breadrcumb links
        // $('#breadcrumbs a').on('click', function(e) {
        //   e.preventDefault();
        //   console.log('Breadcrumb links currently disabled.');
        // })

        // Precheck the subscribe checkbox on the newsletter input
        var checkbox = document.querySelector('.email-signup input[type="checkbox"][name="_mc4wp_subscribe_contact-form-7"]');
    
        if (checkbox) {
            checkbox.checked = true;
        }


        /**
         * Language select
         */

        var $selectLanguage = document.getElementById("select-language"),
            $languageDropdown = document.getElementById("language-dropdown-list");

        if ( $selectLanguage ) {
          $selectLanguage.addEventListener("click", function() {
            $languageDropdown.classList.toggle('hide');
          });
        }

        // Accordions
        jQuery('.accordion-bar').on('click', function() {
          jQuery(this).parent('.accordion-item').toggleClass('open');
        });

        // Toggle filters on mobile
        var sidebarToggle = document.getElementById('sidebar-toggle');
        var widgetLayeredNav = document.getElementById('widget-layered-nav');
        
        if (sidebarToggle) {
          
          sidebarToggle.addEventListener('click', function() {
            // sidebarToggle.style.display = 'none';
            if (sidebarToggle.classList.contains('active')) {
              widgetLayeredNav.classList.remove('show');
              sidebarToggle.classList.remove('active');
              sidebarToggle.textContent = 'Show Filters';
            } else {
              widgetLayeredNav.classList.add('show');
              sidebarToggle.classList.add('active');
                sidebarToggle.textContent = 'Close Filters';
              }
          });
        }

        var categoriesToggle = document.getElementById('sidebar-mobile-toggle');

        if (categoriesToggle) {

          categoriesToggle.addEventListener('click', function() {
            categoriesToggle.style.display = 'none';
            
            // Remove .closed-mobile from .sidebar-secondary with vanilla js
            var sidebarSecondary = document.querySelector('.sidebar-secondary');
            sidebarSecondary.classList.remove('closed-mobile');
            // sidebarToggle.style.display = 'block';
          });

        }



        var header = document.getElementById('header');

        if (header) {

          const hero = document.getElementById('hero');
          const header = document.getElementById('header');
          // Get height of #hero
          var heroHeight = hero ? hero.offsetHeight : 200;
          // console.log('heroHeight :', heroHeight);
          var headerHeight = header ? header.offsetHeight : 100;
          // console.log('headerHeight :', headerHeight);

          $("#header").headroom({
            'offset': heroHeight - headerHeight,
            'tolerance': 5,
          });
        }

        // On click of .header-account toggle class active
        $('.header-account').on('click', function(e) {

          if (!$(this).hasClass('active')) {
            e.preventDefault();
          }
          $(this).toggleClass('active');
        });

        $('.language-select > p').on('click', function(e) {
          if (!$(this).parent().hasClass('sub-menu-open')) {
            e.preventDefault();
          }
          $(this).parent().toggleClass('sub-menu-open');
        });


      },

      detectTouchDevices: function() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function(query) {
          return window.matchMedia(query).matches;
	  	};

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
          return true;
        }

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');

        return mq(query);
      }


      
    },



    // All shop related pages
    'shop': {
      finalize: function() {

        // We no longer use Select2, so wrap our inputs with select-style for styling:
        $("select#billing_country").wrap('<div class="select-style"></div>');
        $("select#billing_state").wrap('<div class="select-style"></div>');
        $("select#shipping_state").wrap('<div class="select-style"></div>');
        $("select#shipping_country").wrap('<div class="select-style"></div>');
        $("select#address_book").wrap('<div class="select-style"></div>');

        // Refresh the selects when country changes
        $('form.checkout').on('change', '#billing_country', function(){
          if (!$("select#billing_country").parent().hasClass('select-style')) {
            $("select#billing_country").wrap('<div class="select-style"></div>');
          }
          if (!$("select#billing_state").parent().hasClass('select-style')) {
            $("select#billing_state").wrap('<div class="select-style"></div>');
          }
          if (!$("select#shipping_state").parent().hasClass('select-style')) {
            $("select#shipping_state").wrap('<div class="select-style"></div>');
          }
          if (!$("select#shipping_country").parent().hasClass('select-style')) {
            $("select#shipping_country").wrap('<div class="select-style"></div>');
          }
          if (!$("select#address_book").parent().hasClass('select-style')) {
            $("select#address_book").wrap('<div class="select-style"></div>');
          }
        });

        // Country notification bar on shop pages
        var $notificationBar = document.getElementById('notification-bar');

        if ($notificationBar) {
          if (localStorage.getItem('country-notification-hide') !== '1') {
            $notificationBar.classList.add('show');
          }
        }

        var $hideNotification = document.getElementById('hide-notification');

        if ($hideNotification) {
          $hideNotification.addEventListener('click', function() {
            localStorage.setItem('country-notification-hide', '1');
            $notificationBar.classList.remove('show');
          });
        }

        // Open register form on button click
        $('#register-button').on('click', function(e) {
          e.preventDefault();

          $('#register-form').addClass('active');
          $(this).hide();
        });

        // Sidebar widgets open/close
        $(document).on('click', '.sidebar-title', function() {
          $(this).parent('.widget_layered_nav').toggleClass('fixed-height');
        });

        // On page load, show the active filters (previously were all closed)
        $(".filter-selected").closest(".widget_layered_nav").removeClass("fixed-height");
        // If active filters, show them on load
        $("li.chosen").closest(".widget_layered_nav").removeClass("fixed-height");

        // On click sidebar filter, enable/disable the checkbox so ajax doesnt refresh whole page
        $(".ajax-layered input").on('click', function() {
          $(this).parent('li').toggleClass('chosen');
          if ($(this).attr('checked')) {
            // console.log('li clicked and is already checked');
            $(this).attr('checked', false);

          }
          else {
            // console.log('li clicked and  wasnt checked');
            $(this).attr('checked', true);

          }
        });

        // Activate product image zooming
        if ( $.isFunction($.fn.zoom) ) {
          $('.zoom-product').zoom();
        }

      },
    },
    'page_template_template_contact_us': {
      finalize: function() {

        $('.locations select').on('change', function() {

          $('.ajax-loading').show();

          jQuery.ajax({
            url: js_vars.ajaxurl,
            type: 'POST',
            data: {
              action: 'contact_location_change',
              locationSlug: this.value,
            },
            success: function(data) {
              $('.ajax-loading').hide();
              $('.location-ajax').html(data);
            },
          });

        });

      },
    },

  'page_template_template_product_selector': {
    init: function() {
      var $oSection = $('section.product-selector');
      var $oForm = $('.form-container form', $oSection);

      $oForm.on('change', '[name="product-type"]', this.productTypeChanged.bind(this));
      $oForm.on('submit', this.formSubmitted.bind(this));

    },

    productTypeChanged: function($oEvent) {
      // console.log('product type changed');
      var $oSection = $('section.product-selector');
      var $oSelect = $($oEvent.currentTarget);
      var $oFields = $('.field', $oSection).not('.field-product-type');

      // Hide/show correct fields of form
      var $oFieldsSelects = $('*[data-filter="'+$oSelect.val()+'"]');
      $oFields.addClass('hidden');
      $oFieldsSelects.removeClass('hidden');
    },

    formSubmitted: function($oEvent) {
      $oEvent.preventDefault();

      // Grab the selections:
      var $oSelect = $('[name="product-type"]');
      var $sProductType = $($oSelect).val();
      var $oFieldsSelects = $('*[data-filter="'+$oSelect.val()+'"]');
      var $oSelectMatches = $('#select-matches');

      $($oSelectMatches).addClass('hidden');

      // console.log($sProductType);
      // console.log('$oFieldsSelects:');
      // console.log($oFieldsSelects);

      // Build search string to append to URL:
      var $sSearchString = '';
      var $bNotFirst = false;
      for (var i = 0; i < $oFieldsSelects.length; i++ ) {

        var $sSelectValue = $($oFieldsSelects[i]).find('select').val();
        var $sSelectText = $($oFieldsSelects[i]).find('select').attr("name");

        // Skip if value is empty
        if ($sSelectValue === null || $sSelectValue === '') {
			continue;
		}

        // If it is the first filter, append the ?
        if ($bNotFirst === false) {
          $sSearchString += '?';
        } else {
          $sSearchString += '&';
        }
        $sSearchString += 'filter_' + $sSelectText + '=' + $sSelectValue;

        $bNotFirst = true;
      }

      if ($sSearchString !== null && $sSearchString !== '') {
        // Build the search URL
        $sUrl = js_vars.siteurl + '/buy-online/' + $sSearchString;
        // Redirect browser
        window.location.href = $sUrl;
      } else {
        $($oSelectMatches).removeClass('hidden');
      }

    }
  },

  'page_template_template_calculator': {
    init: function() {
      var $oSection = $('section.dry-ice-calculator');
      var $oForm = $('.form-container form', $oSection);

      $oForm.on('submit', this.formSubmitted.bind(this));
      $oForm.on('change', '[name="measurement_units"]', this.unitsChanged.bind(this));
      $oSection.on('click', '.back-to-calc', this.backToCalculator.bind(this));
    },

    backToCalculator: function($oEvent) {
      var $oButton = $($oEvent.currentTarget);
      var $oSection = $oButton.closest('section.dry-ice-calculator');
      var $oFormContainer = $('.form-container', $oSection);

      $oFormContainer.show();
      $('.result-container, .no-result-container').remove();
    },

    unitsChanged: function($oEvent) {
      var $oSelect = $($oEvent.currentTarget);
      var $oSection = $oSelect.closest('section.dry-ice-calculator');
      $oSection.removeClass('metric imperial');
      $oSection.addClass($oSelect.val());
    },

    formSubmitted: function($oEvent) {
      $oEvent.preventDefault();
      var $oSelf = this;
      var $oForm = $($oEvent.currentTarget);
      var $oFormContainer = $oForm.closest('.form-container');
      var $oSection = $oForm.closest('section.dry-ice-calculator');
      var $oFormData = new FormData($oForm[0]);

      $oSection.addClass('loading');

			var $oDeferred = $.ajax({
				url: window.ajaxurl,
				contentType: false,
				data: $oFormData,
				dataType: 'JSON',
				processData: false,
				type: 'POST'
			});

			$oDeferred.always(function() {
				$oSection.removeClass('loading');
			});

			$oDeferred.done(function($aProducts) {
				$oFormContainer.hide();

				if($aProducts instanceof Array && $aProducts.length > 0) {
					$oSelf.displayResults($oSection[0], $aProducts);
				} else {
					$oSelf.displayNoResults($oSection[0]);
				}
			});
		},

		displayResults: function($oSection, $aProducts) {
			$oSection = $($oSection);

			var $oHtml = $($('script.result-template', $oSection).html());
			var $oFormContainer = $('.form-container', $oSection);
			var $bMetric = $aProducts[0].unit_of_measurement === 'metric';

            $('.buy-online', $oHtml).attr('href', $aProducts[0].url);
            $('.image-column .image', $oHtml).css('background-image', "url('" + $aProducts[0].image + "')");
            $('.system-suggested', $oHtml).html($aProducts[0].name || '');
            $('.mass', $oHtml).html(($aProducts[0].mass || '') + (($bMetric) ? ' kg' : ' lb'));
            $('.volume', $oHtml).html(($aProducts[0].volume || '') + (($bMetric) ? ' Liters' : ' Cubic inches'));
            $('.loss_rate', $oHtml).html(($aProducts[0].loss_rate || '') + (($bMetric) ? ' grams/hour' : ' oz/hour'));

			$oHtml.insertAfter($oFormContainer);
		},

		displayNoResults: function($oSection) {
			$oSection = $($oSection);
			var $oHtml = $($('script.no-result-template', $oSection).html());
			var $oFormContainer = $('.form-container', $oSection);
			$oHtml.insertAfter($oFormContainer);
		}
	}
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/),
        function(i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, 'finalize');
        });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
